import styled from 'styled-components';

const GroupBadge = styled.span`
  background: ${props => props.theme.enigmaGreyLight};
  border-radius: 4px;
  color: ${props => props.theme.fontSecondary};
  font-size: ${props => props.theme.font.fontSm};
  padding: 4px 10px;
`;

export default GroupBadge;
